import { render, staticRenderFns } from "./MarketplaceProductModal.vue?vue&type=template&id=d23dde1e&scoped=true&"
import script from "./MarketplaceProductModal.vue?vue&type=script&lang=js&"
export * from "./MarketplaceProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23dde1e",
  null
  
)

export default component.exports